const features = [
  {
    icon: 'ri-shield-keyhole-line',
    tag: 'VPN',
    title: 'Invisible Shield',
    description:
      'Military-grade encryption tunnels your internet traffic through secure servers worldwide, masking your IP and keeping your online activity completely private from trackers, ISPs, and malicious actors.',
    bg: 'bg-stone-900',
    textColor: 'text-white',
    tagColor: 'bg-white/10 text-white/70',
    img: 'https://public.readdy.ai/ai/img_res/f181558b11faf37cb7357fe1c06c3348.jpg',
  },
  {
    icon: 'ri-speed-line',
    tag: 'Cleaner',
    title: 'Peak Performance',
    description:
      'Smart cache analysis and junk file detection reclaim precious storage in seconds. Your device runs faster, cooler, and more efficiently — every single day.',
    bg: 'bg-amber-50',
    textColor: 'text-stone-900',
    tagColor: 'bg-stone-900/10 text-stone-700',
    img: 'https://readdy.ai/api/search-image?query=Bright%20clean%20abstract%20speed%20and%20performance%20visualization%2C%20soft%20warm%20cream%20and%20amber%20background%2C%20flowing%20light%20particles%2C%20smooth%20motion%20blur%20lines%2C%20minimalist%20iOS%20app%20aesthetic%2C%20no%20text%2C%20airy%20composition&width=600&height=400&seq=chiko-cleaner-card&orientation=landscape',
  },
  {
    icon: 'ri-smartphone-line',
    tag: 'iOS Native',
    title: 'Crafted for iPhone',
    description:
      'Every pixel and interaction is tuned specifically for iOS. Seamless integration with system features, zero battery drain overhead, and a native feel that users love.',
    bg: 'bg-stone-100',
    textColor: 'text-stone-900',
    tagColor: 'bg-stone-300/60 text-stone-600',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20iOS%20app%20interface%20concept%2C%20soft%20light%20gray%20and%20white%20tones%2C%20gentle%20rounded%20shapes%2C%20minimal%20clean%20mobile%20UI%20pattern%2C%20flat%20design%2C%20no%20text%2C%20airy%20open%20composition&width=600&height=400&seq=chiko-ios-card&orientation=landscape',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-24 md:py-32 bg-stone-50 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-4">
          <div>
            <p className="text-xs text-stone-400 tracking-[0.3em] uppercase font-medium mb-3">Our Products</p>
            <h2
              className="text-4xl md:text-5xl font-bold text-stone-900 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Apps That Make<br />
              <span className="italic font-normal">a Difference</span>
            </h2>
          </div>
          <p className="text-stone-500 text-sm max-w-xs leading-relaxed">
            Two powerful products. One unified mission — to give iOS users the privacy and performance they deserve.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((f) => (
            <div
              key={f.tag}
              className={`rounded-3xl overflow-hidden flex flex-col ${f.bg}`}
            >
              {/* Image area */}
              <div className="w-full h-52 overflow-hidden">
                <img
                  src={f.img}
                  alt={f.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Content */}
              <div className="p-7 flex flex-col flex-1 gap-3">
                <span className={`self-start text-xs px-3 py-1 rounded-full font-medium tracking-wide ${f.tagColor}`}>
                  {f.tag}
                </span>
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className={`${f.icon} text-xl ${f.textColor} opacity-70`} />
                </div>
                <h3 className={`text-xl font-semibold ${f.textColor}`} style={{ fontFamily: "'Playfair Display', serif" }}>
                  {f.title}
                </h3>
                <p className={`text-sm leading-relaxed ${f.textColor} opacity-60`}>
                  {f.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
